import React, { Component } from 'react';
import Promise from 'bluebird';
import { Modal, ModalBody, ModalFooter, Message, ProgressIndicator, Button } from 'sabre-spark-react';

const noop = () => {};

class DialogModal extends Component {
    constructor(props) {
        super(props);
        this.promiseDelegates = {
            resolve: noop,
            reject: noop
        };
        this.state = {
            isOpen: false
        };
    }
    ask(proxy, action, guard = true, isActionRequired = true) {
        if (guard) {
            this.setState({
                isOpen: true
            });
            const askPromise = new Promise((resolve, reject) => {
                this.promiseDelegates.resolve = resolve;
                this.promiseDelegates.reject = reject;
            }).then(() => {
                return Promise.method(proxy)().then(() => {
                    if (isActionRequired) {
                        action();
                    }
                });
            }, action);
            return askPromise;
        } else {
            return Promise.method(action)();
        }
    }
    answer(value) {
        this.setState({
            isOpen: false
        });
        if (value) {
            this.promiseDelegates.resolve(value);
        } else {
            this.promiseDelegates.reject(value);
        }
    }
    render() {
        return (
            <Modal isOpen={this.state.isOpen} isComplex={true} isNotDismissible={true}>
                <ModalBody>
                    <Message title="All unsaved changes will be lost." type="warning" inline={true} />
                    <nav className="spark-btn-group">
                        <Button
                            secondary={true}
                            onClick={() => {
                                this.answer(false);
                            }}
                        >
                            Discard
                        </Button>
                        <Button
                            onClick={() => {
                                this.answer(true);
                            }}
                        >
                            Save
                        </Button>
                    </nav>
                </ModalBody>
            </Modal>
        );
    }
}

export { DialogModal };



// WEBPACK FOOTER //
// ./src/components/widgets/CodeEditor/DialogModal.js